import { AutoComplete, Col, Input, Row } from 'antd';
import { SearchIcon } from 'assets/Icons/AppointmentIcons';
import AvatarBox from 'components/AvatarBox';
import Modal from 'components/Modal';
import colorTheme from 'constants/color';
import { memo, useMemo, useState } from 'react';
import shopSelectors from 'services/shop/selectors';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';
type Props = {
  visible?: boolean;
  onClose?: () => void;
  onChooseStaff: (val: IStaffItemData) => void;
  onChooseAllStaff?: () => void;
  preventAnyone?: boolean;
};
const ModalChooseStaff = ({ preventAnyone = false, visible, onClose = () => undefined, onChooseStaff, onChooseAllStaff }: Props) => {
  const staffs = shopSelectors.data.staffs();
  const [textSearch, setTextSearch] = useState('');
  const staffOpts = useMemo(() => {
    if (preventAnyone) return staffs.filter(o => !o.anyBody).map(o => ({ label: o.nickName, value: o.id }));

    return staffs.map(o => ({
      label: o.nickName,
      value: o.id,
    }));
  }, [staffs, preventAnyone]);

  const onSelect = (value: string) => {
    const staffItem = staffs.find((item) => item.id === value);
    if (!staffItem) return;
    onChooseStaff(staffItem);
    onClose();
    setTextSearch('');
  };

  const _onChooseAllStaff = () => {
    if (onChooseAllStaff) onChooseAllStaff();
    onClose();
  };

  const staffFilter = useMemo(() => {
    return staffOpts.filter(o => o.label?.toLocaleLowerCase().includes(textSearch.toLocaleLowerCase()));
  }, [textSearch, staffOpts]);

  return (
    <Modal
      width={'70vw'}
      className='modal-add-new-appointment modal-max-height-unset'
      modalTitle='SELECT STAFF'
      headerBgColor={colorTheme.info_bg_3}
      visible={visible}
      hiddenOkButton
      noneBodyStyle
      containerPadding={1.5}
      onClose={onClose}
      showClose
      footer={<></>}
      hiddenFooter
    >
      <AutoComplete
        style={{ width: '100%' }}
        options={staffFilter}
        onSelect={onSelect}
        value={textSearch}
        onChange={setTextSearch}
      >
        <Input
          placeholder='Staff name'
          suffix={<SearchIcon />}
        />
      </AutoComplete>
      <ListContainer>
        <Row gutter={[16, 16]} justify="start">
          {!!onChooseAllStaff && <Col
            span={4}
            onClick={_onChooseAllStaff}
          >
            <AvatarBox
              src={''}
              name={'All staff'}
            />
          </Col>}
          {staffs.map((item) => {
            return (
              <Col
                key={item.id}
                span={4}
                onClick={() => onSelect(item.id)}
              >
                <AvatarBox
                  src={item.urlImage}
                  name={item.nickName}
                />
              </Col>
            );
          })}
        </Row>
      </ListContainer>
    </Modal>
  );
};

export default memo(ModalChooseStaff);

const ListContainer = styled.div`
  padding: 1.5rem 1rem;
  height: 30rem;
  overflow: auto;
  .staff-item {
    display:flex;
    flex-direction: column;
  }
`;
